module.exports = __webpack_public_path__ + "static/img/kayo.31c9d032.png";